import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable';
// import ThreeStepsHeadingModal from '../Modal/ThreeStepsModal/ThreeStepsHeadingModal';
// import ThreeStepsCardDesignModal from '../Modal/ThreeStepsModal/ThreeStepsCardDesignModal';
import { Grid } from '@mui/material';
// import OffersCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';
import CommonCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';
import OfferSectionModal from '../Modal/OffersModal/OfferSectionModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
// import ReferSection from './ReferralsPreview/ReferSection';
import ReferralsHeadingModal from '../../CommonModal/ReferModal/ReferralsHeadingModal';
import FinancialConsultantHeadingModal from '../Modal/FinancialConsultantModal/FinancialConsultantHeadingModal';
import AreYouFinancial from './FinancialConsultant/AreYouFinancial';

const FinancialConsultantSection = () => {


    const tableData = [
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

    ];
    // const tableHeadData = ['S.No', 'Title', 'Content', "Document", 'Status'];

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [editCardsData, setEditCardsData] = useState(
        [
            { card_title: 'Card 1', card_content: 'Content 1', image: null },
            { card_title: 'Card 2', card_content: 'Content 2', image: null },
            { card_title: 'Card 3', card_content: 'Content 3', image: null },
            { card_title: 'Card 4', card_content: 'Content 4', image: null }
        ]
    );

    //   ================================================

    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Title', 'Sub Text', 'Content', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "Status"]
        : ['S.No', 'Title', 'Sub Text', 'Content', 'Status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    // const { getStakeNowSectionById } = useSelector(state => state?.getStakeNowSectionById);
    // const { addStakeNowSectionPost } = useSelector(state => state?.addStakeNowSectionPost);

    const { updateStakeNowSection } = useSelector(
        (state) => state?.updateStakeNowSection
    );


    const { deleteStakeNowSection } = useSelector(
        (state) => state?.deleteStakeNowSection
    );


    const { addHomeSectionPost } = useSelector(
        (state) => state?.addHomeSectionPost
    );

    const { getAllHomeSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllHomeSectionsWithCreatorBySectionName
    );

    const { getAllHomeSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllHomeSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllHomeSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addHomeSectionWithApproval } = useSelector(
        (state) => state?.addHomeSectionWithApproval
    );

    const { deleteHomeSection } = useSelector(
        (state) => state?.deleteHomeSection
    );

    const { updateHomeSection } = useSelector(
        (state) => state?.updateHomeSection
    );

    const { updateHomeSectionForReApproval } = useSelector(
        (state) => state?.updateHomeSectionForReApproval
    );

    const { approveHomeSection } = useSelector((state) => state?.approveHomeSection);
    const { rejectHomeSection } = useSelector((state) => state?.rejectHomeSection);



    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "financialconsultant" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllHomeSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLHOMESECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "financialconsultant" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllHomeSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLAHOMESECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)
                console.log(responseData?.payload, "responseDataruejwhrjek")


            }
        }


        fetchData();
    }, [addHomeSectionPost, approveHomeSection, rejectHomeSection, addHomeSectionWithApproval, deleteHomeSection, updateHomeSection, updateHomeSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllHomeSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    subtext: data?.sub_heading || '--',
                    content: data?.content || '--',
                    section_id: data?.section_id || '--',
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllHomeSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    subtext: data?.sub_heading || '--',
                    content: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"

                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllHomeSectionsBySectionNameBasedOnCreator, getAllHomeSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteHomeSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEHOMESECTION(data1));
        if (responseData?.payload?.message === "Home section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }

    // ==========================================================================

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableDelete={permissions?.ContentManagement?.Home.delete}
                    // editData={editCardsData}
                    editModalName={FinancialConsultantHeadingModal}

                    tableView={true}
                    modalVeiwName={PreviewComponent}

                    ModalPreviewComponent1={AreYouFinancial}
                    handleTableDataDelete={handleTableDataDelete}
                    sectionNameForApproveAndReject="HomeSection"


                    // section_name="offers"
                    tableEdit={permissions?.ContentManagement?.Home.edit}
                    dataCreate={permissions?.ContentManagement?.Home.add}
                    tableData={rowTableData} title="Referrals" tableHeadData={tableHeadData} modalName={FinancialConsultantHeadingModal} />

            </Grid>
        </Grid>
    )
}

export default FinancialConsultantSection